import type { ReactNode } from "react";
import { Button } from "@cliqsuite/ui";

export function SettingsPanel({ title, description, children, className = "" }: { title: string; description: string; children: ReactNode; className?: string }) {
  return (
    <section className={`owner-settings-panel${className ? ` ${className}` : ""}`}>
      <header className="owner-settings-panel__header">
        <div><h3>{title}</h3><p>{description}</p></div>
      </header>
      <div className="owner-settings-panel__body">{children}</div>
    </section>
  );
}

export function SettingsToggleRow({ title, description, children }: { title: string; description: string; children: ReactNode }) {
  return (
    <div className="owner-settings-toggle-row">
      <div><strong>{title}</strong><p>{description}</p></div>
      {children}
    </div>
  );
}

export function SettingsSaveBar({ dirty, label, scope, onSave, onDiscard }: { dirty: boolean; label: string; scope: "store" | "business"; onSave: () => void; onDiscard: () => void }) {
  if (!dirty) return null;
  return (
    <div className={`owner-settings-savebar owner-settings-savebar--${scope}`}>
      <div className="owner-settings-savebar__state is-dirty">
        <span className="ms" aria-hidden="true">edit_note</span>
        <strong>{scope === "store" ? "Unsaved changes to this store" : "Unsaved changes to your business"}</strong>
      </div>
      <button type="button" className="owner-settings-savebar__discard" onClick={onDiscard}>
        Discard
      </button>
      <Button onClick={onSave}>
        <span className="ms" aria-hidden="true">check</span>
        {label}
      </Button>
    </div>
  );
}
